import React from 'react';
import PropTypes from 'prop-types';
import TimelineDot from '@mui/lab/TimelineDot';
import { withStyles } from '@mui/styles';

const CustomTimelineDot = withStyles({
  root: {
    margin: '0',
  },
})(TimelineDot);

const UiTimelineDot = (props) => {
  return <CustomTimelineDot {...props} />;
};

UiTimelineDot.propTypes = {
  children: PropTypes.array,
};

export default UiTimelineDot;
